module.exports = __webpack_public_path__ + "img/result-icon.6feb9ae.png";